import React from 'react'
import type { FC } from 'react'
import { ChevronRight } from 'lucide-react'
import { Card } from '@/components/card'
import { AdBlock } from '@/payload/blocks/ad-block/component'

import type { Post } from '@payload-types'

interface PostSidebarProps {
  latestPosts: Post[]
}

export const PostSidebar: FC<PostSidebarProps> = ({ latestPosts }) => {
  if (!latestPosts || latestPosts.length === 0) return null

  return (
    <div className="col-span-12 md:col-span-3">
      <div className="flex flex-col gap-4">
        {/* Latest News Box */}
        <div className="flex flex-col gap-4 max-h-max h-max bg-white rounded-lg p-4 mb-6 scrollbar-hide">
          <div className="flex flex-row items-center gap-2">
            <ChevronRight className="w-4 h-4 text-primary" />
            <p className="font-bold">Son Haberler</p>
          </div>

          <div className="flex flex-col gap-4 max-h-max h-max scrollbar-hide">
            {latestPosts.map((post) => (
              <Card key={post.id} doc={post} variant="secondary" />
            ))}
          </div>
        </div>

        {/* Sidebar Ad Block */}
        <div className="sticky top-4">
          <AdBlock className="w-full" />
        </div>
      </div>
    </div>
  )
}
